<template>
  <div v-if="loading">
    <Loading />
  </div>
    <div v-else class="mt-3">
        <module-header>
            <h1>{{ $t('gamification.subjects') }}</h1>
            <PrimaryButton v-if="getAllSubjects.length > 0" @click="createSubject()" class="mr-8">
                {{$t('gamification.add_subject')}}
            </PrimaryButton>
        </module-header>

        <div class="mt-5">
          <confirm-dialog
              :error-message="errorMessage"
              :is-open="subjectToDelete"
              :loading="deleteLoading"
              :title="$t('gamification.archive_subject')"
              :subtitle="$t('gamification.confirm_archive_subject')"
              :confirm-button-text="$t('gamification.archive')"
              @close="closeConfirmDialog"
              @confirm-click="deleteSubject()" />

          <v-text-field v-if="getAllSubjects.length > 0" v-model="search"  :placeholder="$t('gamification.search_subject')" prepend-icon="search" variant="underlined" width="50%" />

          <v-data-table
              v-if="getAllSubjects.length > 0"
              :headers="headers"
              :items="getAllSubjects"
              :search="search"
              items-per-page="25"
              mobile-breakpoint="sm"
          >
            <template v-slot:no-data>
              {{$t('gamification.no_data')}}
            </template>
            <template v-slot:item.name="{item}">
                <b class="text-xs-left pointer light-green--text"
                   @click="goToPortal(item.id)">{{ item.name }}</b>
            </template>
            <template v-slot:item.code="{item}">
                <span>{{ item.code }}</span>
            </template>
            <template v-slot:item.owner="{item}">
                <span>{{ item.owner.fullName }}</span>
            </template>
            <template v-slot:item.actions="{item}">
              <div class="d-flex ga-1">
                <v-btn @click="goToDetail(item.id)" color="grey-darken-3" variant="text" size="small" icon="edit" />
                <v-btn @click="subjectToDelete = item" color="deep-orange-darken-2" variant="text" size="small" icon="archive" />
              </div>
            </template>
          </v-data-table>

          <div
              class="w-100 d-flex flex-column justify-center align-center"
              v-if="getAllSubjects.length === 0">
            <img
                style="width: 400px"
                :src="noSubjectsImage"
                alt="noSubjectsImage">
            <div class="text-h5">{{$t('gamification.no_subjects')}}</div>
            <div class="text-h6 font-weight-light text-grey-darken-1">{{$t('gamification.no_subjects_added')}}</div>
            <PrimaryButton class="mt-5" @click="createSubject()">
              {{$t('gamification.add_subject')}}
            </PrimaryButton>
          </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ModuleHeader from "@/components/layout/ModuleHeader";
import PrimaryButton from "@/components/buttons/PrimaryButton";
import NoSubjects from '@/assets/gamification/no_subjects.png';
import Loading from "@/components/Loading.vue";
import ConfirmDialog from "@/components/gamification/ConfirmDialog.vue";


export default {
    name: "Subjects",

    components: {ConfirmDialog, Loading, PrimaryButton, ModuleHeader},

    async created() {
      this.loading = true
      await this.fetchAllSubjects();
      this.loading = false
    },

    data() {
        return {
            dialog: false,
            noSubjectsImage: NoSubjects,
            loading: false,
            deleteLoading: false,
            search: '',
            subjectToDelete: null,
            errorMessage: '',
            headers: [
              { key: 'name', title: this.$t('gamification.name'), align: 'start', width: '60%' },
              { key: 'code', title: this.$t('gamification.code'), align: 'start', width: '15%' },
              { key: 'owner', title: this.$t('gamification.admin'), align: 'start', width: '15%'},
              { key: 'actions', title: this.$t('gamification.action'), align: 'center', sortable: false, width: '10%'}]
        }
    },

    computed: {
        ...mapGetters('Subjects', ['getSubjects', 'getSubjectById']),

        getAllSubjects() {
            return this.getSubjects;
        }
    },

    methods: {
        ...mapActions('Subjects', ['fetchAllSubjects', 'deleteSubjectById']),

        createSubject() {
            this.$router.push({name: 'SubjectDetail', params: {subjectId: "new"}})
        },

        goToDetail(subjectId) {
            this.$router.push({name: 'SubjectDetail', params: {subjectId: subjectId}})
        },

        async deleteSubject(){
          if(this.subjectToDelete){
            try {
              this.deleteLoading = true
              await this.deleteSubjectById(this.subjectToDelete.id)
              this.errorMessage = ''
              this.subjectToDelete = null
            } catch (e) {
              this.errorMessage = 'Chyba. Zkuste to prosím později znovu.'
              console.log('error ', e)
            } finally {
              this.deleteLoading = false
            }
          }
        },
        closeConfirmDialog(){
          this.subjectToDelete = null
          this.errorMessage = ''
        },
        goToPortal(subjectId) {
            this.$router.push({
                name: 'Gamification',
                params: {subjectId: subjectId, tab: 'tests'}
            });
        },
    }
}
</script>

<style scoped>

</style>